const listeners = new Set();

function emit(type, payload) {
  for (const fn of listeners) fn(type, payload);
}

export const modal = {
  // Provider가 구독
  _subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },

  // 공통 open (Promise 반환)
  open(config = {}) {
    return new Promise((resolve) => {
      emit("open", { ...config, _resolve: resolve });
    });
  },

  // 편의 API
  confirm(opts = {}) {
    return modal.open({ type: "confirm", ...opts });
  },
  alert(opts = {}) {
    return modal.open({ type: "alert", ...opts });
  },
  // 완전 커스텀 렌더러
  custom(renderFn, opts = {}) {
    return modal.open({ type: "custom", render: renderFn, ...opts });
  },

  // 강제 닫기
  close(result) {
    emit("close", result);
  },
};
